'use strict';

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * actually makes the requests to the server
 */

module.exports = function (ops) {
    return new Promise(function (resolve, reject) {

        var method = ops.method.toLowerCase();

        var r = _superagent2['default'][{
            'delete': 'del'
        }[method] || method](ops.url);

        if (ops.form) {
            r.type('form');
        }

        if (ops.headers) {
            for (var key in ops.headers) {
                r.set(key, ops.headers[key]);
            }
        }

        if (ops.query) {
            r.query(ops.query);
        }

        if (ops.data) {
            r.send(ops.data);
        }

        r.end(function (err, res) {

            if (err) {
                return reject(err);
            }

            res = res.text;

            try {
                res = JSON.parse(res);
            } catch (e) {}

            resolve(res);
        });
    });
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/api/_request.js
 ** module id = 666
 ** module chunks = 0 1
 **/